import { ANALYTICS_PATHS } from '@/constants/analytics-paths';
import SecondarySidebarLayout from './secondary-sidebar-layout';
import type { SecondarySidebarGroup } from './secondary-sidebar-layout';

const GROUPS: SecondarySidebarGroup[] = [
	{
		heading: 'Support',
		items: [
			{ label: 'Overview', path: ANALYTICS_PATHS.SUPPORT_OVERVIEW },
			{ label: 'Performance', path: ANALYTICS_PATHS.SUPPORT_PERFORMANCE }
		]
	},
	{
		heading: 'Ticket Inflow',
		items: [
			{ label: 'Overview', path: ANALYTICS_PATHS.INFLOW_OVERVIEW },
			{ label: 'Message Metrics', path: ANALYTICS_PATHS.INFLOW_MESSAGE_METRICS },
			{ label: 'Ticket Metrics', path: ANALYTICS_PATHS.INFLOW_TICKET_METRICS }
		]
	}
];

export default function AnalyticsLayout() {
	return <SecondarySidebarLayout title='Analytics' groups={GROUPS} />;
}
